import { useRef } from 'react'

import { getTabSessionId } from './sessionStorage'

export const useSessionStorageTabIdTracking = () => {
  const tabSessionIdRef = useRef<string>(getTabSessionId())

  return tabSessionIdRef.current
}
